<template>
    <div class="main-content">
        <div class="uk-padding" v-if="u">
            <ul class="uk-breadcrumb">
                <li><router-link to="/users">Gebruikers</router-link></li>
                <li><router-link :to="{ name: 'UserDetail', params: { id: $route.params.id }}">{{u.displayName}}</router-link></li>
                <li><router-link :to="{ name: 'UserEdit', params: { id: $route.params.id }}">Bewerken</router-link></li>
            </ul>
            <h1>Gegevens Bewerken</h1>
            <div class="uk-margin">
                <input class="uk-input" type="text" v-model="u.displayName" placeholder="Volledige naam">
            </div>
            <div class="uk-margin">
                <input class="uk-input" type="text" v-model="u.firstname" placeholder="Voornaam">
            </div>
            <div class="uk-margin">
                <input class="uk-input" type="text" v-model="u.lastname" placeholder="Naam">
            </div>
            <div class="uk-margin">
                <input class="uk-input" type="text" :disabled="true" v-model="u.email" placeholder="Email">
            </div>
            <div class="uk-margin">
                <select class="uk-select" v-model="role">
                    <option :value="i" v-for="(r, i) in userRoles">{{r}}</option>
                </select>
            </div>
            <div class="uk-margin">
                <button @click="update" class="uk-button uk-button-primary"><span v-if="!loading">Save</span><div v-if="loading" uk-spinner></div></button>
            </div>
        </div>
    </div>
</template>
<script>
import {db} from '@/CUSTOM/helpers/firebase'
    export default {
        name: 'UserDetail',
        data () {
            return {
                u: null,
                role: null,
                loading: false,
                userRoles: ["Gebruiker", "Moderator", "Beheerder"]
            }
        },
        methods: {
            update () {
                this.loading = true
                Promise.all([db.collection('users').doc(this.$route.params.id).update(this.u), db.collection('users-secure').doc(this.$route.params.id).update({role: this.role+1})]).then(res => {
                    this.loading = false
                    this.$router.push('/users')
                })
            }
        },
        created () {
           db.collection('users').doc(this.$route.params.id).onSnapshot((snap) => {
               this.u = snap.data()
           })
           db.collection('users-secure').doc(this.$route.params.id).onSnapshot((snap) => {
               this.role = snap.data().role - 1
           })
           if(this.$store.state.core.user.role >= 4){
               this.userRoles.push('Admin')
           }
        }
}
</script>


// WEBPACK FOOTER //
// UserEdit.vue?f9ff176c